import { Badge } from "@/components/ui/badge";

const statusConfig = {
  pending: { className: "bg-slate-100 text-slate-600", label: "Pending" },
  in_progress: { className: "bg-blue-100 text-blue-700", label: "In Progress" },
  outreach_sent: { className: "bg-amber-100 text-amber-700", label: "Outreach Sent" },
  responses_received: { className: "bg-teal-100 text-teal-700", label: "Responses Received" },
  completed: { className: "bg-lime-100 text-lime-700", label: "Completed" },
  closed: { className: "bg-slate-100 text-slate-500", label: "Closed" },
  active: { className: "bg-lime-100 text-lime-700", label: "Active" },
  draft: { className: "bg-slate-100 text-slate-600", label: "Draft" },
  archived: { className: "bg-slate-100 text-slate-500", label: "Archived" },
  suspended: { className: "bg-red-100 text-red-700", label: "Suspended" },
  invited: { className: "bg-blue-100 text-blue-700", label: "Invited" },
  active_recruit: { className: "bg-blue-100 text-blue-700", label: "Active Recruit" },
  succession_planning: { className: "bg-amber-100 text-amber-700", label: "Succession Planning" },
};

export default function StatusBadge({ status, className = "" }) {
  const config = statusConfig[status] || { className: "bg-slate-100 text-slate-600", label: status };
  return (
    <Badge data-testid={`status-badge-${status}`} className={`${config.className} border-0 font-accent text-xs ${className}`}>
      {config.label}
    </Badge>
  );
}
